// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"e38f6f0e","208":"d79bb161","256":"1379a18b","420":"bb383fdc","592":"1de15096","600":"7c8fda10","796":"cdda77eb","804":"1bdc66f2"}[chunkId] + ".chunk.js";
};